// API Configuration
// Tüm API endpoint'leri ve ayarları buradan yönetilir

// App Version: the image tag, passed at build time (Dockerfile ARG APP_VERSION)
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';

export const API_CONFIG = {
  // Production by default; a local build for end-to-end runs sets REACT_APP_API_BASE_URL
  // (e.g. http://127.0.0.1:5001/api). The Docker image does not, so it always talks to prod.
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.riselio.com/api',
  
  // Timeouts (milliseconds)
  TIMEOUTS: {
    DEFAULT: 300000,      // 5 dakika - Normal API istekleri için
    AI_OPERATIONS: 600000, // 10 dakika - AI işlemleri için
  },
  
  // Headers
  HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Token Keys
  TOKEN_KEYS: {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
  },

  // Address MCP clients connect to with a personal access token
  MCP_SERVER_URL: 'https://mcp.riselio.com/mcp',

  GOOGLE: {
    CLIENT_ID: '879572625319-smcomqcf4a8gf8rkfe1a268jh1akth23.apps.googleusercontent.com',
  },
  
  // Endpoints
  ENDPOINTS: {
    // Auth
    LOGIN: '/login',
    REGISTER: '/register',
    GOOGLE_LOGIN: '/auth/google',
    LOGOUT: '/logout',
    ME: '/me',
    REFRESH: '/refresh',
    
    // Password Reset
    PASSWORD_FORGOT: '/password/forgot',
    PASSWORD_RESET_VERIFY: '/password/reset/verify',
    PASSWORD_RESET: '/password/reset',
    PASSWORD_SETUP: '/password/setup',
    PASSWORD_CHANGE: '/password/change',

    // Email verification
    EMAIL_VERIFY: '/email/verify',
    EMAIL_VERIFY_RESEND: '/email/verify/resend',
    EMAIL_VERIFY_CODE: '/email/verify-code',
    
    // Profile
    PROFILE_UPDATE: '/profile',
    
    // Account
    ACCOUNT_DELETE: '/account/delete',
    ACCOUNT_EXPORT: '/account/export',

    // MCP access tokens (Settings > Connections)
    MCP_TOKENS: '/mcp/tokens',
    // "Sign in with Riselio" for MCP apps: consent screen and connected apps
    OAUTH_REQUESTS: '/oauth/requests',
    OAUTH_GRANTS: '/oauth/grants',
    
    // AI
    AI_TODO_GENERATE: '/todos/ai/generate-detail',
    AI_GOAL_GENERATE: '/ai/generate-goal-plan',
    AI_JOB_CREATE: '/ai/jobs',
    AI_JOB_STATUS: '/ai/jobs',

    // Goal summary email
    GOAL_SEND_SUMMARY: '/goals',  // usage: `/goals/${id}/send-summary`
  },
};

// Environment helper
export const isProduction = process.env.NODE_ENV === 'production';
